import { formatDate } from './formatDate';

/**
 * Formats an ISO datetime into a localized `dd/MM/yyyy HH:mm` string.
 *
 * Reuses the timezone-safe {@link formatDate} for the calendar date and lifts the
 * time straight from the ISO string (no `new Date()` offset drift). Falls back to
 * the date alone when there is no `HH:mm`, and to the em-dash placeholder for
 * empty/absent values. Generic — not tied to any feature.
 */
export function formatDateTime(value?: string | null): string {
  if (!value) return '—';
  const date = formatDate(value, 'dd/MM/yyyy');
  const time = /T(\d{2}):(\d{2})/.exec(value);
  return time ? `${date} ${time[1]}:${time[2]}` : date;
}
